import { ROUTES } from "../../../api/api.routes";
import useCustomQuery, { QueryOpts } from "../../../hooks/useQuery";
import { ChatHistory, ChatMessage } from "../../../types";

const EMPTY: ChatMessage[] = [];

export const useChatHistory = (h: ChatHistory, opts?: QueryOpts) => {

  const { data, mutate } = useCustomQuery<ChatMessage[]>(ROUTES.ChatHistory.query(h), {
    ...opts,
    enabled: false,
    cacheTime: Infinity
  });

  return {
    chatHistory: data ?? EMPTY,
    isLoading: false,
    mutate
  }
}